import { SEARCH_RESULT_FETCH_DATA_SUCCESS, SEARCH_RESULT_HAVE_ERROR, SEARCH_RESULT_ARE_LOADING } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function searchResultAction(action, payload) {
    switch (action) {
        case SEARCH_RESULT_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };
    
        case SEARCH_RESULT_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };
    
        case SEARCH_RESULT_FETCH_DATA_SUCCESS:
            return {
                type: action,
                searchResult: payload,
            };

        default:
            return;
    }
}

export function searchResult(searchParams = '') {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(searchResultAction(SEARCH_RESULT_ARE_LOADING, true));
                Get(HttpService.searchResult+searchParams).then((result) => {
                    dispatch(searchResultAction(SEARCH_RESULT_FETCH_DATA_SUCCESS, result));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(searchResultAction(SEARCH_RESULT_HAVE_ERROR, true));
        }
    }
}
